(() => {
  const STORAGE_KEY = 'strawberry.savedIdeas.v1';
  const PRODUCT_PATH = /\/products\/([^/?#]+)/i;
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.7-7.5 1.1-1.1a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  let toastTimer;

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(item => typeof item === 'string' && item.length < 180))] : [];
    } catch (_) { return []; }
  };

  const write = handles => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(handles)]));
    document.dispatchEvent(new CustomEvent('strawberry:saved-ideas-changed'));
  };

  const handleFromUrl = url => {
    try { return new URL(url, location.origin).pathname.match(PRODUCT_PATH)?.[1] || ''; }
    catch (_) { return ''; }
  };

  const productLinkFor = card => [...card.querySelectorAll('a[href*="/products/"]')].find(link => handleFromUrl(link.href));

  const titleFor = (card, link) => {
    const titleNode = card.querySelector('[class*="title"], h2, h3, .product__title');
    return (titleNode?.textContent || link?.getAttribute('aria-label') || 'this item').trim().replace(/\s+/g, ' ');
  };

  const announce = message => {
    let status = document.querySelector('[data-saved-ideas-status]');
    if (!status) {
      status = document.createElement('div');
      status.className = 'strawberry-saved__status';
      status.dataset.savedIdeasStatus = '';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      document.body.append(status);
    }
    status.textContent = message;
    status.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => status.classList.remove('is-visible'), 2200);
  };

  const isSaved = handle => read().includes(handle);

  const updateButton = (button, title, saved) => {
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${title} ${saved ? 'from' : 'to'} Saved Ideas`);
    const text = button.querySelector('[data-save-label]');
    if (text) text.textContent = saved ? 'Saved' : 'Save for later';
  };

  const toggle = (handle, title) => {
    const handles = read();
    const saved = handles.includes(handle);
    write(saved ? handles.filter(item => item !== handle) : [...handles, handle]);
    announce(saved ? `${title} removed from Saved Ideas.` : `${title} saved.`);
  };

  const updateAll = () => {
    const handles = read();
    document.querySelectorAll('[data-saved-ideas-count]').forEach(node => {
      node.textContent = String(handles.length);
      node.hidden = handles.length === 0;
    });
    document.querySelectorAll('[data-save-handle]').forEach(button => updateButton(button, button.dataset.saveTitle || 'this item', handles.includes(button.dataset.saveHandle)));
  };

  const addCardButtons = root => {
    (root || document).querySelectorAll?.('.product-grid-item:not([data-saved-ideas-ready])').forEach(card => {
      const link = productLinkFor(card);
      const handle = link && handleFromUrl(link.href);
      if (!handle) return;
      const title = titleFor(card, link);
      card.dataset.savedIdeasReady = 'true';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ss-saved-idea-button';
      button.dataset.saveHandle = handle;
      button.dataset.saveTitle = title;
      button.innerHTML = heart;
      updateButton(button, title, isSaved(handle));
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        toggle(handle, title);
      });
      card.prepend(button);
    });
  };

  const addProductButton = async () => {
    const handle = location.pathname.match(PRODUCT_PATH)?.[1];
    if (!handle || document.querySelector('.ss-product-save')) return;
    const target = document.querySelector('.product__block__buttons, .product__submit__buttons');
    if (!target) return;
    let title = document.querySelector('h1')?.textContent?.trim() || 'this item';
    try {
      const product = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`).then(response => response.ok ? response.json() : Promise.reject(response));
      title = product.title || title;
    } catch (_) {}
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ss-product-save';
    button.dataset.saveHandle = handle;
    button.dataset.saveTitle = title;
    button.innerHTML = `${heart}<span data-save-label></span>`;
    updateButton(button, title, isSaved(handle));
    button.addEventListener('click', () => toggle(handle, title));
    target.append(button);
  };

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(Number(cents || 0) / 100);

  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };

  const renderSavedPage = async () => {
    const page = document.querySelector('[data-saved-ideas-page]');
    if (!page) return;
    const grid = page.querySelector('[data-saved-ideas-grid]');
    const empty = page.querySelector('[data-saved-ideas-empty]');
    const summary = page.querySelector('[data-saved-ideas-summary]');
    const handles = read();
    summary.textContent = `${handles.length} saved ${handles.length === 1 ? 'item' : 'items'} · saved on this device`;
    empty.hidden = handles.length > 0;
    grid.hidden = handles.length === 0;
    grid.replaceChildren();
    if (!handles.length) return;

    const products = await Promise.all(handles.map(async handle => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`);
        return response.ok ? response.json() : null;
      } catch (_) { return null; }
    }));

    products.forEach((product, index) => {
      const handle = handles[index];
      if (!product) return;
      const item = make('article', 'strawberry-saved__item');
      const imageLink = make('a', 'strawberry-saved__image');
      imageLink.href = product.url || `/products/${handle}`;
      const image = new Image();
      image.loading = 'lazy';
      image.alt = product.title || '';
      image.src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src || product.images?.[0] || '';
      imageLink.append(image);
      const vendor = make('p', 'strawberry-saved__vendor', product.vendor || 'The Strawberry Shop');
      const heading = make('h2', 'strawberry-saved__title');
      const titleLink = make('a', '', product.title || 'View product');
      titleLink.href = imageLink.href;
      heading.append(titleLink);
      const price = make('p', 'strawberry-saved__price', money(product.price));
      const remove = make('button', 'strawberry-saved__remove', 'Remove');
      remove.type = 'button';
      remove.addEventListener('click', () => {
        write(read().filter(itemHandle => itemHandle !== handle));
        announce(`${product.title} removed from Saved Ideas.`);
        renderSavedPage();
      });
      item.append(imageLink, vendor, heading, price, remove);
      grid.append(item);
    });
  };

  const bindSavedPage = () => {
    const page = document.querySelector('[data-saved-ideas-page]');
    if (!page || page.dataset.bound === 'true') return;
    page.dataset.bound = 'true';
    page.querySelector('[data-saved-ideas-clear]')?.addEventListener('click', () => {
      if (!read().length || !window.confirm('Remove every item from Saved Ideas?')) return;
      write([]);
      announce('Saved Ideas cleared.');
      renderSavedPage();
    });
    page.querySelector('[data-saved-ideas-copy]')?.addEventListener('click', async () => {
      const links = read().map(handle => `${location.origin}/products/${handle}`).join('\n');
      if (!links) return announce('Save an item before copying your list.');
      try { await navigator.clipboard.writeText(links); announce('Product links copied.'); }
      catch (_) { announce('Your browser could not copy the links.'); }
    });
    renderSavedPage();
  };

  const init = () => {
    addCardButtons(document);
    addProductButton();
    bindSavedPage();
    updateAll();
    document.addEventListener('strawberry:saved-ideas-changed', updateAll);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (!(node instanceof Element)) return;
      if (node.matches('.product-grid-item')) addCardButtons(node.parentElement);
      else addCardButtons(node);
    }))).observe(document.body, { childList: true, subtree: true });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once: true }) : init();
})();
